<template>
    <v-list-tile>
        <v-dialog v-model="mostrarDialogoCancelar" persistent :max-width="Modal.Processamento.larguraMaxima">
            <v-list-tile-title slot="activator">
                <i class="fas fa-ban mr-2" aria-hidden="true"/>
                Cancelar
            </v-list-tile-title>

            <modal-alterar-situacao-lote-e-item v-model="lista" :title="'Cancelar'"
                                                @salvarAlteracaoSituacao="tratarEventoCancelar"
                                                @fecharModalAlteracao="tratarEventoFecharModal"/>
        </v-dialog>
    </v-list-tile>
</template>

<script>
import ModalAlterarSituacaoLoteEItem from './ModalAlterarSituacaoLoteEItem'
import {actionTypes, Modal} from '@/core/constants'

export default {
    name: 'AcoesCancelar',
    components: {ModalAlterarSituacaoLoteEItem},
    props: {
        compraDiretaId: {
            required: true
        }
    },
    data() {
        return {
            lista: {
                itens: [],
                itensDisponiveis: [],
                itensIndisponiveis: [],
                lotes: [],
                lotesDisponiveis: [],
                lotesIndisponiveis: []
            },
            mostrarDialogoCancelar: false,
            Modal
        }
    },
    methods: {
        async tratarEventoCancelar(objModal) {
            const objParaCancelar = {
                compraDiretaId: this.compraDiretaId,
                dados: {
                    itens: objModal.itens,
                    lotes: objModal.lotes,
                    motivo: objModal.motivo,
                    situacao: 'CANCELADO'
                }
            }
            await this.$store.dispatch(actionTypes.ALTERAR_SITUACAO_DE_ITEM_E_LOTE, objParaCancelar)
            this.mostrarNotificacaoSucesso('Item cancelado com sucesso.')
            this.tratarEventoFecharModal()
        },
        async buscarResumoItensLotes() {
            this.lista = await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_ITEM_E_LOTE, this.compraDiretaId)
        },
        tratarEventoFecharModal() {
            this.mostrarDialogoCancelar = false
            this.lista = {
                itens: [],
                itensDisponiveis: [],
                itensIndisponiveis: [],
                lotes: [],
                lotesDisponiveis: [],
                lotesIndisponiveis: []
            }
        }
    },
    watch: {
        'mostrarDialogoCancelar': {
            async handler(novoValor) {
                if (novoValor) {
                    try {
                        await this.buscarResumoItensLotes()
                    } catch (e) {
                        this.mostrarNotificacaoErro(e.message)
                    }
                }
            }
        }
    }
}
</script>

<style scoped lang="stylus">
    .v-dialog__container
        width 100%
</style>
